import { uid } from 'uid';

export const getuid = (size = 14) => uid(size)

export const isValidNumber = (value) => /^[0-9]*$/i.test(value)
